import { createSelector } from '@reduxjs/toolkit';
export const projectsReducerSelector = createSelector([(state) => state.projects], (projects) => projects);
